import sortByPriority from './sortByPriority'
import isArrayNotNull from './isArrayNotNull'
import type { Query, Sg_MenuLink } from '~/schema/types/generated'

export default function sortMenuQueryByPriority(query: Query) {
    if (!query || !query.sg_menulinks) {
        return query
    }
    const sortMenuLinks = (menuLinks: Sg_MenuLink[]) => {
        return menuLinks?.map((link) => {
            const sortedTopBarItems = sortByPriority(isArrayNotNull(link.sg_topBarItems || []))?.map((topBarItem) => {
                const sortedContainers = sortByPriority(isArrayNotNull(topBarItem.sg_containers || []))?.map(
                    (container) => {
                        const sortedItems = sortByPriority(isArrayNotNull(container.sg_items || []))?.map((item) => {
                            const sortedLinks = sortByPriority(isArrayNotNull(item?.sg_links || []))
                            return { ...item, sg_links: sortedLinks }
                        })
                        return { ...container, sg_items: sortedItems }
                    },
                )
                return { ...topBarItem, sg_containers: sortedContainers }
            })
            return { ...link, sg_topBarItems: sortedTopBarItems }
        })
    }

    const sortedMenuLinks = sortMenuLinks(isArrayNotNull(query?.sg_menulinks))
    return { ...query, sg_menulinks: sortedMenuLinks }
}
